<template>
  <el-dialog :destroy-on-close="true"
             title="更改项目关联用户"
             :visible.sync="showDialog"
             :before-close="cancel"
             width="600px">
    <el-form :model="form" label-width="120px">
      <el-form-item label="分析人员" v-if="isHasAnalyze">
        <el-select class="userInput" v-model="form.selectedAnalyze" filterable placeholder="请选择">
          <el-option
              v-for="(item,index) in analyzerList"
              :key="index"
              :label="item.name"
              :value="item.uuid">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="销售">
        <el-select class="userInput" v-model="form.selectedSalers" filterable :multiple="isHasAnalyze" placeholder="请选择">
          <el-option
              v-for="(item,index) in saleList"
              :key="index"
              :label="item.name"
              :value="item.uuid">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户">
        <el-select class="userInput" v-model="form.selectedCustomers" filterable multiple placeholder="请选择客户邮箱"
                   remote
                   :remote-method="remoteType"
                   @change="changeEmail">
          <el-option
              v-for="(item,index) in customerList"
              :key="index"
              :label="item.emailAccount"
              :value="item.emailAccount">
          </el-option>
        </el-select>
      </el-form-item>
      <span style="color: #dd6161">注：更换的客户必须在系统内；若不在，请前往"客户管理"添加客户</span>
    </el-form>
    <span slot="footer" class="dialog-footer">
              <el-button @click="cancel">取 消</el-button>
              <el-button type="primary" @click="handle">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
import {userList} from "@/api/dilivery/user";
import {customerList} from "@/api/dilivery/customer";

export default {
  name: "ChangeUsers",
  props:{
    isHasAnalyze: {
      type: Boolean,
      default: true
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    selectDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        projectId: '',
        selectedAnalyze: '',
        selectedSalers: '',
        selectedCustomers: [],
      },
      saleList: [],
      analyzerList: [],
      customerList: []
    }
  },
  watch: {
    'selectDetail': {
      handler(newVal) {
        if (newVal) {
          this.form.selectedAnalyze = newVal.selectedAnalyze
          this.form.selectedSalers = newVal.selectedSalers
          this.form.selectedCustomers = newVal.selectedCustomers
          this.form.projectId = newVal.projectId
          this.form.selectedCustomersInfo = newVal.selectedCustomersInfo
        }
      },
      immediate: true
    }

  },
  created() {
    this.getUser()
  },
  methods: {
    // //获取人员信息（分析、销售 ）
    getUser() {
      userList('ANALYST', {'page.current': 1, 'page.size': 200}, {}).then(response => {
        this.analyzerList = response.data.records
      })
      userList('SALES', {'page.current': 1, 'page.size': 200}, {}).then(response => {
        this.saleList = response.data.records
      })
      customerList({'page.current': 1, 'page.size': 200}, {emailAccounts: this.form.selectedCustomers}).then(response => {
        this.customerList = response.data.records
      })
    },
    remoteType(query) {
      if (query) {
        var param = {
          'page.current': 1,
          'page.size': 200,
        }
        customerList(param, {emailAccount: query}).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.customerList = res.data.records
          }
        })
      }
    },
    changeEmail() {
      var param = {
        'page.current': 1,
        'page.size': 200,
      }
      customerList(param, {emailAccounts: this.form.selectedCustomers}).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.customerList = res.data.records
        }
      })
    },
    async handle() {
      if (this.form.selectedCustomers && this.form.selectedCustomers.length > 0) {
        var param = {
          'page.current': 1,
          'page.size': 200,
        }
        const res = await customerList(param, {emailAccounts: this.form.selectedCustomers})
        this.loading = false
        this.form.customerIds = res.data.records.map(item => item.id)
        this.$emit('submit', this.form, 'submit')
      } else {
        this.$messageUi.error('请选择客户邮箱')
      }

    },
    cancel() {
      this.$emit('submit', this.form, 'cancel')
    }
  }
}
</script>

<style scoped>
/deep/ .userInput {
  display: flex;
  width: 100% !important;
}
</style>
